import { render, staticRenderFns } from "./status-change-modal.vue?vue&type=template&id=6c801ceb&"
import script from "./status-change-modal.vue?vue&type=script&lang=ts&"
export * from "./status-change-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports